<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppTitledBox from '@/components/app/titledBox.vue';
import AppBox from '@/components/app/box.vue';
// -------------------------
import MissionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import MissionTransformMixin from '@/Mixins/Mission/mission.transform';
import SharedHelper from '@/Helpers/Shared';
export default {
  components: { AppTitleHeader, AppTitledBox, AppBox },
  mixins: [MissionNoteMixin, MissionTransformMixin, SharedHelper],
  inject: ['load'],
  props: {
    missionPhoneId: {
      type: Number,
      default: 0,
    },
    missionId: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.getMissionDescription();
  },
  data() {
    return {
      noteText: '',
    };
  },
  methods: {
    getMissionDescription: function () {
      if (this.missionId && this.missionPhoneId) {
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
      }
    },
    saveDescription: function () {
      if (!this.noteText) {
        this.showErrorAlert('توضیحات نمی تواند خالی باشد');
      } else {
        this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
      }
    },
  },
};
</script>
<template>
  <v-row no-gutters class="pa-4">
    <v-col cols="12">
      <app-title-header title="توضیحات" />
      <v-row class="descriptions-container">
        <v-col v-for="{
          id,
          note,
          jalaliNoteDate,
          authorFullName,
          authorPhoneNumber,
        } in transformedInformation.missionDescriptions" :key="id" cols="12">
          <v-row no-gutters>
            <v-col cols="3">
              <v-row no-gutters>
                <v-col cols="3">
                  <v-icon class="main-icon" color="white">mdi-account mdi-20px</v-icon>
                </v-col>
                <v-col cols="9" class="pr-2">
                  <div class="mb-2 flex-gap-1">
                    <div class="author-full-name-text">
                      {{ authorFullName }}
                    </div>
                    <div>({{ authorPhoneNumber }})</div>
                  </div>
                  <div>
                    {{ jalaliNoteDate }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9" class="pr-2">
              <app-box>
                {{ note }}
              </app-box>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="mt-4">
      <app-titled-box title="افزودن توضیحات" class="add-description-box">
        <v-col cols="12">
          <v-textarea hide-details label="توضیحات" outlined class="mb-2" v-model="noteText" />
          <div>
            <v-btn text dark @click="saveDescription" color="darkColor">
              <v-icon>mdi-plus mdi-20px</v-icon>
              افزودن توضیحات
            </v-btn>
          </div>
        </v-col>
      </app-titled-box>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
.descriptions-container {
  & {
    height: 300px;
    overflow-y: auto;
  }

  .main-icon {
    background: var(--dark-color);
    padding: 4px !important;
    border-radius: 50% !important;
  }

  .author-full-name-text {
    font-weight: 600;
  }
}

.add-description-box {
  border: 1px solid var(--dark-color);
}
</style>
